function twoDigits(value) {
  if (value.toString().length <= 1) {
    return '0' + value.toString();
  }

  return value.toString();
}


function parseDate(str) {
  return str.match(/(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2})/).slice(1, 6);
}

$(function() {
  // Sets unit totals
  window.setInterval(function() {

    var start_input = document.querySelector('.progress-timer--units-container');
    var endinput = document.querySelector('.progress-timer--units-container');

     if(start_input != null || endinput != null ){
      var starttime = start_input.dataset.start;
      var endtime = endinput.dataset.end;
  


    var now = Math.trunc((new Date()).getTime() / 1000);
    var start = Math.trunc(Date.parse(starttime) / 1000);
    var deadline = Math.trunc(Date.parse(endtime) / 1000);
    
  var percentage = Math.min(Math.round(((now - start) / (deadline - start)) * 100), 100);
    var secondsRemaining = deadline - now;
    
    if (secondsRemaining < 0) {
      secondsRemaining = 0;
    }

    document.getElementById('progress-timer--days').innerHTML = twoDigits(Math.trunc((secondsRemaining) / 60 / 60 / 24));
    document.getElementById('progress-timer--hours').innerHTML = twoDigits(Math.trunc((secondsRemaining) / 60 / 60) % 24);
    document.getElementById('progress-timer--minutes').innerHTML = twoDigits(Math.trunc((secondsRemaining) / 60) % 60);
    document.getElementById('progress-timer--seconds').innerHTML = twoDigits((secondsRemaining) % 60);
    
    document.getElementById('progress-timer--bar-bg').style.width = percentage + '%';

  }



  }, 1000);

  
});





window.theme = window.theme || {};

theme.imageSlider = function () {

  function imageSlide(element) {
    $(".image-slider").not('.slick-initialized').slick({
      infinite: true,
      arrows: false,
      prevArrow: `<div class="slick-prev slick-arrow"></div>`,
      nextArrow: `<div class="slick-next slick-arrow"></div>`,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 3000
    });

  }

  return imageSlide;


}();


theme.customBanner = function () {

  function customBannerSlider(element) {
    $(".banner-slider").not('.slick-initialized').slick({
      autoplaySpeed: 1000,
      pauseOnHover: true,
      arrows: false,
      dots: true,
      infinite: true,
      prevArrow: `<button class="slick-prev slick-arrow"><svg fill="currentColor" height="24px" width="24px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.006 512.006" xml:space="preserve"> <g> <g> <path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0 L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251 c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/> </g> </g> </svg></button>`,
      nextArrow: `<button class="slick-next slick-arrow"><svg fill="currentColor" height="24px" width="24px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"> <g> <g> <path d="M388.418,240.915L153.752,6.248c-8.331-8.331-21.839-8.331-30.17,0c-8.331,8.331-8.331,21.839,0,30.17L343.163,256 L123.582,475.582c-8.331,8.331-8.331,21.839,0,30.17c8.331,8.331,21.839,8.331,30.17,0l234.667-234.667 C396.749,262.754,396.749,249.246,388.418,240.915z"/> </g> </g> </svg</button>`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false
          }
        }
      ]
    });

  }

  return customBannerSlider;


}();





theme.imageGallery = function () {

  function Gallery(element) {

    $('.gallery-slider').not('.slick-initialized').slick({
      autoplaySpeed: 1000,
      pauseOnHover: true,
      arrows: true,
      dots: false,
      infinite: true,
      prevArrow: `<button class="slick-prev slick-arrow"><svg fill="currentColor" height="24px" width="24px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.006 512.006" xml:space="preserve"> <g> <g> <path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0 L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251 c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/> </g> </g> </svg></button>`,
      nextArrow: `<button class="slick-next slick-arrow"><svg fill="currentColor" height="24px" width="24px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"> <g> <g> <path d="M388.418,240.915L153.752,6.248c-8.331-8.331-21.839-8.331-30.17,0c-8.331,8.331-8.331,21.839,0,30.17L343.163,256 L123.582,475.582c-8.331,8.331-8.331,21.839,0,30.17c8.331,8.331,21.839,8.331,30.17,0l234.667-234.667 C396.749,262.754,396.749,249.246,388.418,240.915z"/> </g> </g> </svg</button>`,
      fade: false,
      asNavFor: '.slider-nav',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false
          }
        }
      ]
    });
    $('.slider-nav').not('.slick-initialized').slick({
      slidesToShow: 12,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      focusOnSelect: true,
      asNavFor: '.gallery-slider',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }
      ]

    });




  }

  return Gallery;


}();

theme.Sections = function () {
  this.constructors = {};
  this.instances = [];
  document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this));
  document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this));
  document.addEventListener("shopify:section:select", this._onSelect.bind(this));
  document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this));
  document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this));
  document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");
    constructor = constructor || this.constructors[type];
    if (!(typeof constructor > "u")) {
      var instance = Object.assign(new constructor(container), { id, type, container });
      this.instances.push(instance);
    }
  }, _onSectionLoad: function (evt) {
    var container = document.querySelector('[data-section-id="' + evt.detail.sectionId + '"]');
    if (container) {
      this._createInstance(container);
    }
  }, _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;
      if (isEventInstance && typeof instance.onUnload == "function") {
        instance.onUnload(evt);
      }
      return !isEventInstance;
    });
  }, _onSelect: function (evt) {
    var instance = this.instances.find(function (instance2) {
      return instance2.id === evt.detail.sectionId;
    });
    if (typeof instance < "u" && typeof instance.onSelect == "function") {
      instance.onSelect(evt);
    }
  }, _onDeselect: function (evt) {
    var instance = this.instances.find(function (instance2) {
      return instance2.id === evt.detail.sectionId;
    });
    if (typeof instance < "u" && typeof instance.onDeselect == "function") {
      instance.onDeselect(evt);
    }
  }, _onBlockSelect: function (evt) {
    var instance = this.instances.find(function (instance2) {
      return instance2.id === evt.detail.sectionId;
    });
    if (typeof instance < "u" && typeof instance.onBlockSelect == "function") {
      instance.onBlockSelect(evt);
    }
  }, _onBlockDeselect: function (evt) {
    var instance = this.instances.find(function (instance2) {
      return instance2.id === evt.detail.sectionId;
    });
    if (typeof instance < "u" && typeof instance.onBlockDeselect == "function") {
      instance.onBlockDeselect(evt);
    }
  }, register: function (type, constructor) {
    this.constructors[type] = constructor;
    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(function (container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});


document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections;

  sections.register("text-with-image-slider", theme.imageSlider);
  sections.register("image-gallery", theme.imageGallery);
  sections.register("collection-banner-custom", theme.customBanner);


});



$(document).on('submit', 'form.enterform', function () {


  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('form.enterform').serialize(),
    success: function (data) {
      window.location.href = '/checkout';
    },
    error: 'addToCartFail'
  });




});


Fancybox.bind("[data-fancybox='image']", {
  groupAll: true,
  Thumbs: false,
  Toolbar: {
    display: {
      left: ["infobar"],
      middle: [],
      right: ["close"]
    }
  }

});



Fancybox.bind("[data-fancybox='gallery']", {
  groupAll: true,
  Thumbs: false,
  Toolbar: {
    display: {
      left: ["infobar"],
      middle: [],
      right: ["close"]
    }
  }

});
Fancybox.bind("[data-fancybox='other-gallery']", {
  groupAll: true,
  Thumbs: false,
  Toolbar: {
    display: {
      left: ["infobar"],
      middle: [],
      right: ["close"]
    }
  }

});









// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function (event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function () {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });


$(document).ready(function () {

 
  if( getCookie('receive-cookie-deprecation') != 'yes'){ 
    if(getCookie('receive-cookie-deprecation') != 'no' ){
    

      setTimeout(function() { 
        $('.popup').css("display", "flex").hide().fadeIn();
    }, 3000);


    }
  }

  $('.close-btn').click(function(e){
    e.preventDefault();
    $('.popup').fadeOut();
    
    setCookie( 'receive-cookie-deprecation', 'no', 7 );
  });
  
  $('.nothanks-btn').click(function(e){
    e.preventDefault();
    $('.popup').fadeOut();
    setCookie( 'receive-cookie-deprecation', 'yes', 30 );

  });
  
  $(".popup-overlay").click(function(e){
    e.preventDefault();
    $('.popup').fadeOut();
    setCookie( 'receive-cookie-deprecation', 'no', 7 );
  });



  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }




  $('.accordion__head').on('click', function() {
    if($(this).hasClass('active')) {
    $(this).siblings('.accordion__contentp').slideUp();
    $(this).removeClass('active');
    }
    else {
    $('.accordion__contentp').slideUp();
    $('.accordion__head').removeClass('active');
    $(this).siblings('.accordion__contentp').slideToggle();
    $(this).toggleClass('active');
    }
}); 






var href = $(location).attr("pathname");
var search = $(location).attr("search");
var filter__serach_path = href+""+search;



$('.modal-open').on('click', function() {
  $('.quote_popup').css("display", "flex").hide().fadeIn();

}); 

$(".quote_popup-overlay, .quote_popup-btn").click(function(e){
  e.preventDefault();
  $('.quote_popup').fadeOut();
  if( filter__serach_path.indexOf("?") > 0  &&  filter__serach_path.indexOf("contact_posted=true") != -1 ){
    window.location.replace(href);
  }

});


if( filter__serach_path.indexOf("?") > 0  &&  filter__serach_path.indexOf("contact_posted=true") != -1 ){

  $('.quote_popup').css("display", "flex").hide().fadeIn();
  $('.quote_popup').addClass("hideFields");
}


  


});




$(document).on('click','.video-container__play',function(e) {
  e.preventDefault();
  var poster = $(this);
  var wrapper = poster.closest('.video-container');
  videoPlay(wrapper);
});

function videoPlay(wrapper) {
  var iframe = wrapper.find('.js-videoIframe');
  var src = iframe.data('src');
  wrapper.addClass('videoWrapperActive');
  iframe.attr('src',src);
}



var player = $('.video-container--autoplay'); 
 videoPlay(player);


 


//  function formToJSON(elements) {
// 	return [].reduce.call(elements, function (data, element) {
// 		data[element.name] = element.value;
// 		return data;
// 	}, {});
// }

// function getUrlString(data) {
// 	var urlParameters = Object.entries(data).map(function (e) {
// 		return e.join('=');
// 	}).join('&');

// 	return urlParameters;
// }

// function initForm(selector) {
// 	selector = selector || '#ContactForm';

// 	document.querySelectorAll(selector).forEach(function(form) {
// 		var action = form.getAttribute("data-action"),
// 			alert = form.querySelector('[data-alert="status"]'),
// 			inputs = form.querySelectorAll("[name]"),
// 			btn = form.querySelector('[type="button"]');

// 		// Submit data via Fetch
// 		form.addEventListener('submit', function(e){
// 			e.preventDefault();

// 			fetch(action, {
// 				method: 'POST',
// 				headers: {
// 					"Content-Type": "application/x-www-form-urlencoded",
// 					"Accept": "application/json"
// 				},
// 				body: getUrlString(formToJSON(inputs))
// 			}).then(function(response) {
// 				console.log(response);
// 				console.log("Response Status: " + response.status);
// 				alert.className = "alert alert-success";
// 				alert.innerHTML = "Thank you for contacting us. We will be in touch.";
// 			}).catch(function(error) {
// 				console.log(error);
// 				console.log("Response Status: " + response.status);
// 				alert.className = "alert alert-danger";
// 				alert.innerHTML = "We had an issue receiving your form. Please try again later.";
// 			});
// 		});
// 	});
// }

// initForm();



class SlideshowsComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');

    if (!this.slider) return;
    
    this.initPages();

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);
  }
  
  
  initPages() {
    const sliderActive = this.slider.id;
    const slick = $("#" + sliderActive);
    slick.not('.slick-initialized').slick({
      prevArrow: `<button class="slick-prev slick-arrow"><svg fill="currentColor" height="24px" width="24px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.006 512.006" xml:space="preserve"> <g> <g> <path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0 L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251 c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/> </g> </g> </svg></button>`,
      nextArrow: `<button class="slick-next slick-arrow"><svg fill="currentColor" height="24px" width="24px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"> <g> <g> <path d="M388.418,240.915L153.752,6.248c-8.331-8.331-21.839-8.331-30.17,0c-8.331,8.331-8.331,21.839,0,30.17L343.163,256 L123.582,475.582c-8.331,8.331-8.331,21.839,0,30.17c8.331,8.331,21.839,8.331,30.17,0l234.667-234.667 C396.749,262.754,396.749,249.246,388.418,240.915z"/> </g> </g> </svg</button>`,
    });

    slick.on("lazyLoaded", function (event, slick, image, imageSource) {
      lazyCounter++;
      if (lazyCounter === lazyImages.length) {
        lazyImages.addClass("show");
      }
    });


  }
}

customElements.define('slideshows-component', SlideshowsComponent);



$('.tab-link').click( function() {
	
	var tabID = $(this).attr('data-tab');
	$(this).addClass('active').siblings().removeClass('active');
	$('#tab-'+tabID).addClass('active').siblings().removeClass('active');
});




// $('.buy-now-btn').on("click", function (e) {
//   e.preventDefault();
  
//   var form = $(this).closest("form");
//   var formParams = form.serialize();
//    $.ajax({
//     url: "/cart/add",
//     type: "post",
//     data: formParams,
//     success: function(){
//       window.location.href = "/checkout";
//     },
//     error: function(){
//     }
//    })

// });


// $('.check__out-button').on("click", function (e) {
//   e.preventDefault();
  
//   var form = $(this).closest("form");
//   var formParams = form.serialize();
//    $.ajax({
//     url: "/cart/add",
//     type: "post",
//     data: formParams,
//     success: function(){
//       window.location.href = "/checkout";
//     },
//     error: function(){
//     }
//    })

// });


